<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <v-select class="w-25"></v-select>
        <v-select class="w-25"></v-select>
        <span class="ml-1 mr-1">for</span>
        <v-select class="w-25"></v-select>
      </div>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <frequency-duration-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <v-select
          style="font-size: 14px"
          class="w-25"
          v-model="frequencyFirstValue"
          :options="
            computedConditions.frequencyFirstOptions
              ? computedPropertiesForm.frequencyFirstOptions
              : properties.frequencyFirstOptions
          "
        ></v-select>
        <v-select
          style="font-size: 14px"
          class="w-25"
          v-model="frequencySecondValue"
          :options="
            computedConditions.frequencySecondOptions
              ? computedPropertiesForm.frequencySecondOptions
              : properties.frequencySecondOptions
          "
        ></v-select>
        <span class="ml-1 mr-1">for</span>
        <v-select
          style="font-size: 14px"
          class="w-25"
          v-model="durationValue"
          :options="
            computedConditions.durationOptions
              ? computedPropertiesForm.durationOptions
              : properties.durationOptions
          "
        ></v-select>
      </div>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
    >
      {{ controlValue }}
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import FrequencyDurationV1Properties from "./FrequencyDurationV1Properties.vue";
export default {
  name: "FrequencyDurationV1",
  components: { FrequencyDurationV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: [
        "description",
        "label",
        "hidden",
        "frequencyFirstOptions",
        "frequencySecondOptions",
        "durationOptions"
      ],
      computedConditions: {}
    };
  },
  mounted() {
    if(this.componentsIdSuffix) {
      this.initializeComponentValue({
        controlId: this.id,
        properties: this.properties
      });
    }
    this.computeConditions();
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${this.controlValue}
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    frequencyFirstValue: {
      get() {
        const parts = this.controlValue.split(" - ");
        if (parts.length == 3) return parts[0];
        return "";
      },
      set(newControlValue) {
        let parts = this.controlValue.split(" - ");
        if (parts.length == 3) {
          parts[0] = newControlValue;
        } else parts = [""];
        this.controlValue = parts.join(" - ");
      }
    },
    frequencySecondValue: {
      get() {
        const parts = this.controlValue.split(" - ");
        if (parts.length == 3) return parts[1];
        return "";
      },
      set(newControlValue) {
        let parts = this.controlValue.split(" - ");
        if (parts.length == 3) {
          parts[1] = newControlValue;
        } else parts = [""];
        this.controlValue = parts.join(" - ");
      }
    },
    durationValue: {
      get() {
        const parts = this.controlValue.split(" - ");
        if (parts.length == 3) return parts[2];
        return "";
      },
      set(newControlValue) {
        let parts = this.controlValue.split(" - ");
        if (parts.length == 3) {
          parts[2] = newControlValue;
        } else parts = [""];
        this.controlValue = parts.join(" - ");
      }
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id)
          ? this.getFormSubmitterComponentValue(this.id)
          : " -  - ";
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
